const axios = require("axios").default
import { decode } from 'js-base64'
import Strings from './mixinStrings.js'
var cookie = require('cookie')

export default {
  data: () => {
    return {
      axios: null,
      global: {
        passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
        rules: {
          email: (v) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || Strings(this, "validation_rule_email"),
          memberReference: (v) => /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*|\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})|[a-z_0-9]+)$/.test(v) || Strings(this, 'validation_rule_member'),
          organisation: (v) => /^[a-z0-9-_.]{3,50}$/.test(v) || Strings(this, "validation_rule_organization"),
          globalid: (v) => /^([a-z0-9-_.]{3,50}\.)*[a-z0-9-_]{3,50}$/.test(v) || Strings(this, "validation_rule_globalid"),
          requiredField: (v) => !!v || Strings(this, "validation_rule_required_field"),
          minLength: (v) => v.length >= 3 || Strings(this, "validation_rule_min_length"),
          optionalHttpsUrl: (v) => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*(\.[a-z]{2,5})?(:[0-9]{1,5})?(\/.*)?$/.test(v) || Strings(this, "validation_rule_https_url"),
          passwordField: (v) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/.test(v) || Strings(this, "validation_rule_password"),
          accessTokenField: (v) => /^[a-z0-9-]{3,50}$/.test(v) || Strings(this, "validation_rule_token"),
        }
      }
    }
  },
  created: function () {
    this.axios = axios.create({headers: { "X-CSRF-Token": document.getElementsByName("gorilla.csrf.Token")[0].value }})
  },
  computed: {
    username: function () {
      return this.$store.state.user.username
    },
    firstname: function () {
      return this.$store.state.user.firstname
    },
    lastname: function () {
      return this.$store.state.user.lastname
    }
  },
  methods: {
    alert(type, message, detailMessage, confirmHandler, hideHandler) {
      switch (type) {
      case "info":
      case "error":
      case "confirm":
        break
      default:
        throw `Invalid alert type (${type})`
      }
      if (/^[a-z_]+$/.test(message)) {
        const msg = Strings(this, message)
        if (msg) message = msg
      }
      if (/^[a-z_]+$/.test(message)) {
        const msg = Strings(this, message)
        if (msg) message = msg
      }
      this.$store.commit('alert', [true, type, message, detailMessage, confirmHandler, hideHandler])
    },
    isAuthRoute(){
      switch (window.location.pathname) {
      case "/login":
      case "/register":
      case "/forgot-password":
      case "/resetpassword":
      case "/verify-login":
        return true
      default: return false
      }
    },
    initSession(callBack) {
      this.isAuthenticated(
        authenticated => {
          if (!authenticated && !this.isAuthRoute()){
            if(window.location.pathname == '/')
              this.$router.push({ name: "Login"})
            else
              this.$router.push({ name: "Login", query: {redirect: encodeURIComponent((location.pathname+location.search).substr(1))}})
          }
          else if(authenticated && this.isAuthRoute()){
            if(typeof this.$route.query.redirect !== 'undefined'){
              this.$router.replace({ path: decodeURIComponent(this.$route.query.redirect)})
            } else {
              this.$router.replace({ name: "Home" })
            }
          }
          callBack()
        }
      )
    },
    isAuthenticated: function (resultHandler) {
      const parsedCookies = cookie.parse(document.cookie)
      let userCookieName = Object.keys(parsedCookies).find(key => key.substring(key.length - 5) == '.user')
      const userName = parsedCookies[userCookieName]
      if (userName) {
        this.$api.getUser(decode(userName), this.callBack(
          response => {
            if (!response.username) {
              resultHandler(false)
            } else {
              this.$store.commit('setUser', response)
              resultHandler(true)
            }
          },
          () => {
            resultHandler(false)
          }, null, true
        ))
      } else {
        resultHandler(false)
      }
    },
    close() {
      this.$router.go(-1)
    },
    restrictNumeric: function (event) {
      switch (event.keyCode) {
      case 8: // backspace
      case 37: // left arrow
      case 39: // right arrow
      case 46: // delete
        return true
      default:
        if (/\d/.test(event.key)) {
          return true
        }
        event.preventDefault()
      }
      return false
    },
    login: function () {
      const parsedCookies = cookie.parse(document.cookie)
      let userCookieName = Object.keys(parsedCookies).find(key => key.substring(key.length - 5) == '.user')
      const userName = parsedCookies[userCookieName]
      this.$api.getUser(decode(userName), this.callBack(
        response => {
          if (response.username) {
            this.$store.commit('setUser', response)
            if (this.$store.state.updatePassword) {
              this.$router.replace({name: 'PasswordChange'})
            }
            else if(typeof this.$route.query.redirect !== 'undefined'){
              this.$router.replace({path: decodeURIComponent(this.$route.query.redirect)})
            } else {
              this.$router.replace({name: 'Home'})
            }
          } else {
            this.alert("something_went_wrong")
          }
        }
      ))
    },
    noPaste: function (event) {
      event.preventDefault()
    },
    callBack(okHandler, errorHandler, finallyHandler, directlyInvokeErrorHandler = false) {
      return (error, data, response) => {
        try {
          if (error) {
            if (error.status == 401 && !directlyInvokeErrorHandler) this.$router.push({ name: "Login" })
            else {
              if (errorHandler)
                errorHandler(error)
              else
                this.alert("error", Strings(this, "something_went_wrong"))
            }
          } else {
            if (okHandler) okHandler(data, response)
          }
        } finally {
          if (finallyHandler) finallyHandler()
        }
      }
    }
  },
}
